/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  EnrollmentMonitoringMapDto,
  GetClientEnrollmentMonitoringParams,
  GetClientMonitoredCriticalElementsParams,
  MonitoredCriticalElementDto,
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **Any authenticated role**
 */
export const getClientEnrollmentMonitoring = (
  userId: string,
  clientId: number,
  params?: GetClientEnrollmentMonitoringParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<EnrollmentMonitoringMapDto>(
    {
      url: `/api/${userId}/clients/${clientId}/critical-elements/v2/monitoring`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetClientEnrollmentMonitoringQueryKey = (
  userId: string,
  clientId: number,
  params?: GetClientEnrollmentMonitoringParams
) => {
  return [
    `/api/${userId}/clients/${clientId}/critical-elements/v2/monitoring`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClientEnrollmentMonitoringQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientEnrollmentMonitoring>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params?: GetClientEnrollmentMonitoringParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientEnrollmentMonitoring>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClientEnrollmentMonitoringQueryKey(userId, clientId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClientEnrollmentMonitoring>>
  > = ({ signal }) =>
    getClientEnrollmentMonitoring(
      userId,
      clientId,
      params,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && clientId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientEnrollmentMonitoring>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientEnrollmentMonitoringQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientEnrollmentMonitoring>>
>;
export type GetClientEnrollmentMonitoringQueryError = ErrorType<unknown>;

export function useGetClientEnrollmentMonitoring<
  TData = Awaited<ReturnType<typeof getClientEnrollmentMonitoring>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params: undefined | GetClientEnrollmentMonitoringParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientEnrollmentMonitoring>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientEnrollmentMonitoring>>,
          TError,
          Awaited<ReturnType<typeof getClientEnrollmentMonitoring>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientEnrollmentMonitoring<
  TData = Awaited<ReturnType<typeof getClientEnrollmentMonitoring>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params?: GetClientEnrollmentMonitoringParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientEnrollmentMonitoring>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientEnrollmentMonitoring>>,
          TError,
          Awaited<ReturnType<typeof getClientEnrollmentMonitoring>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientEnrollmentMonitoring<
  TData = Awaited<ReturnType<typeof getClientEnrollmentMonitoring>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params?: GetClientEnrollmentMonitoringParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientEnrollmentMonitoring>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetClientEnrollmentMonitoring<
  TData = Awaited<ReturnType<typeof getClientEnrollmentMonitoring>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params?: GetClientEnrollmentMonitoringParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientEnrollmentMonitoring>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClientEnrollmentMonitoringQueryOptions(
    userId,
    clientId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **Any authenticated role**
 */
export const getClientMonitoredCriticalElements = (
  userId: string,
  clientId: number,
  params: GetClientMonitoredCriticalElementsParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<MonitoredCriticalElementDto[]>(
    {
      url: `/api/${userId}/clients/${clientId}/critical-elements/v2/monitoring/summaries`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetClientMonitoredCriticalElementsQueryKey = (
  userId: string,
  clientId: number,
  params?: GetClientMonitoredCriticalElementsParams
) => {
  return [
    `/api/${userId}/clients/${clientId}/critical-elements/v2/monitoring/summaries`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClientMonitoredCriticalElementsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientMonitoredCriticalElements>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params: GetClientMonitoredCriticalElementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientMonitoredCriticalElements>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClientMonitoredCriticalElementsQueryKey(userId, clientId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClientMonitoredCriticalElements>>
  > = ({ signal }) =>
    getClientMonitoredCriticalElements(
      userId,
      clientId,
      params,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && clientId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientMonitoredCriticalElements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientMonitoredCriticalElementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientMonitoredCriticalElements>>
>;
export type GetClientMonitoredCriticalElementsQueryError = ErrorType<unknown>;

export function useGetClientMonitoredCriticalElements<
  TData = Awaited<ReturnType<typeof getClientMonitoredCriticalElements>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params: GetClientMonitoredCriticalElementsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientMonitoredCriticalElements>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientMonitoredCriticalElements>>,
          TError,
          Awaited<ReturnType<typeof getClientMonitoredCriticalElements>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientMonitoredCriticalElements<
  TData = Awaited<ReturnType<typeof getClientMonitoredCriticalElements>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params: GetClientMonitoredCriticalElementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientMonitoredCriticalElements>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientMonitoredCriticalElements>>,
          TError,
          Awaited<ReturnType<typeof getClientMonitoredCriticalElements>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientMonitoredCriticalElements<
  TData = Awaited<ReturnType<typeof getClientMonitoredCriticalElements>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params: GetClientMonitoredCriticalElementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientMonitoredCriticalElements>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetClientMonitoredCriticalElements<
  TData = Awaited<ReturnType<typeof getClientMonitoredCriticalElements>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params: GetClientMonitoredCriticalElementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientMonitoredCriticalElements>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClientMonitoredCriticalElementsQueryOptions(
    userId,
    clientId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
